<template>

  <t-page>


    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage">


      <template #search>

        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :fields-custom="entityFieldCustomized('page')"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form">


          <t-input-code-label enterprise
                              v-model="form.enterpriseId"/>

          <t-input-code-label inspector
                              v-model="form.inspectorId"/>


          <t-input-search v-model="form.issueDate" enable-range date label="Data Inspecionado"/>

          <t-input-search v-model="form.checklistStatusId" v-if="typeChecklistStatusOptions.length > 0"
                          :options="typeChecklistStatusOptions"
                          label="Status Operacional" radio/>

          <t-input-search v-model="form.statusChecklist" :options="StatusChecklistType.list"
                          label="Status Inspeção" radio/>

        </t-content-header-search-default>

      </template>

      <b-table hover :items="request.content" v-if="checkViewListTableDefault() && pageListIsLoaded"
               :fields="fields">

        <template #cell(first)="{item}">
          <t-list-link-primary :label="item.checklistNumber" :userAuth="userAuth"
                               :id="item.checklistNumber"
                               formatter="lpad|4"
                               path="custom/checklist/cohab"/>
        </template>

        <template #cell(status)="{item}">
          {{ item.status | statusLabel }}
        </template>

        <template #cell(issueDate)="{item}">
          {{ item.issueDate | date }}
        </template>




      </b-table>

      <t-msg v-else-if="pageListIsLoaded" warning>{{ t('no-record-found') }}</t-msg>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import StatusChecklistType from "@/model/types/modules/checklist/StatusChecklistType";
import TypeChecklistModelService from "@/services/modules/checklist/TypeChecklistModel.service";
import TypeChecklistStatusService from "@/services/modules/checklist/TypeChecklistStatus.service";

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  name: 'ConsorcioCohab9',
  data() {
    return {
      StatusChecklistType,
      path: "checklist", //Utilizar somente quando fora do padrão
      fields: [
        {key: "first", label: "Nº Inspeção"},
        {key: "otherCodeLabel", label: "Cód. Interno"},
        {key: "enterprise", label: "Empreendimento"},
        {key: "inspector", label: "Inspetor"},
        {key: "issueDate", label: "Data Inspeção"},
        {key: "typeChecklistStatus", label: "Status Transmissão"},
        {key: "actions", label: ""},
      ],
      form: {
        enterpriseId: 0,
        inspectorId: 0,
        typeChecklistId: 0,
        checklistStatusId: 12, /*Por padrão exibirá as inspeções pendentes para transmissão*/
        issueDate: "",
        statusChecklist: 2,
        enableSingleEnvironment: null,
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      typeChecklistOptions: [],
      typeChecklistStatusOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

      //Remove busca por status do padrão, pois nesta tela não há status
      delete this.form.status

      this.setIsLoadingPage(true)

    },
    async mountedContinued() {

      this.setMenuPageId(279)

      await TypeChecklistModelService.selectList("").then((list) => {
        this.typeChecklistOptions = list
      }).catch(error => this.responseError(error))

      await TypeChecklistStatusService.selectList("").then((list) => {
        this.typeChecklistStatusOptions = list
      }).catch(error => this.responseError(error))

      this.searchDefault()

      this.setIsLoadingPage(false)

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList(false, false)

    await this.mountedContinued()

  },
}
</script>
